export enum WoundTypeEnum {
  SkinLesion = 1,
  SkinTear = 2,
  PressureUlcerInjury = 3,
  SurgicalWound = 4,
  DiabetesUlcer = 5,
  VenousUlcer = 6,
  ArterialUlcer = 7,
  TraumaWound = 8,
  Other = 99
}

export const WoundTypeOptions = [
{ id: 1, label: 'Skin Lesion' },
{ id: 2, label: 'Skin Tear' },
{ id: 3, label: 'Pressure Ulcer/Injury' },
{ id: 4, label: 'Surgical Wound' },
{ id: 5, label: 'Diabetic Ulcer' },
{ id: 6, label: 'Venous Ulcer' },
{ id: 7, label: 'Arterial Ulcer' },
{ id: 8, label: 'Trauma Wound' },
{ id: 99, label: 'Other' }
];
